module.exports = __webpack_public_path__ + "fonts/7e08cc6.ttf";